module.exports = __webpack_public_path__ + "img/u-lyn-batteri-ladeniveau-forside.8376c49f.svg";